var _defs, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _circle4, _circle5, _circle6, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyTakeawaysIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-5 h-5",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "keyGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E32934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6B75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "keyAccent",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0055A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#keyGradient)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 10,
    fill: "url(#keyGradient)",
    filter: "url(#glow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 5,
    fill: "white",
    opacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    width: 18,
    height: 4,
    rx: 2,
    fill: "url(#keyAccent)",
    filter: "url(#glow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 3,
    height: 6,
    rx: 1,
    fill: "url(#keyAccent)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 24,
    width: 3,
    height: 8,
    rx: 1,
    fill: "url(#keyAccent)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 24,
    width: 3,
    height: 5,
    rx: 1,
    fill: "url(#keyAccent)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 12,
    r: 2,
    fill: "#FFD700",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 18,
    r: 1.5,
    fill: "#FFD700",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 8,
    r: 1,
    fill: "#FFD700",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 20,
    height: 2,
    rx: 1,
    fill: "url(#keyAccent)",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 46,
    width: 26,
    height: 2,
    rx: 1,
    fill: "url(#keyAccent)",
    opacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 52,
    width: 16,
    height: 2,
    rx: 1,
    fill: "url(#keyAccent)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyTakeawaysIcon);
export default __webpack_public_path__ + "static/media/key-takeaways-icon.39b2835377706274edd2bfcb6b859068.svg";
export { ForwardRef as ReactComponent };